var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _path10, _g2, _path11, _g3, _path12, _g4, _path13, _g5, _path14, _g6, _path15, _g7, _path16, _g8, _path17, _g9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoR1May(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 285,
    height: 128,
    viewBox: "0 0 285 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M162.351 78.9914L161.601 83.3714H168.471L167.781 87.2414H160.911L160.071 91.9514H167.841L167.121 96.0014H154.221L157.941 74.9414H170.841L170.121 78.9914H162.351Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M144.034 74.9414C145.974 74.9414 147.644 75.2914 149.044 75.9914C150.464 76.6714 151.544 77.6414 152.284 78.9014C153.044 80.1414 153.424 81.6014 153.424 83.2814C153.424 83.8614 153.354 84.5914 153.214 85.4714C152.854 87.5314 152.074 89.3614 150.874 90.9614C149.694 92.5614 148.184 93.8014 146.344 94.6814C144.524 95.5614 142.514 96.0014 140.314 96.0014H132.424L136.144 74.9414H144.034ZM140.764 91.6214C142.704 91.6214 144.314 91.0814 145.594 90.0014C146.874 88.9214 147.674 87.4114 147.994 85.4714C148.094 84.8714 148.144 84.3714 148.144 83.9714C148.144 82.4914 147.694 81.3514 146.794 80.5514C145.894 79.7314 144.614 79.3214 142.954 79.3214H140.494L138.334 91.6214H140.764Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M117.131 92.2814H109.271L107.351 96.0014H101.981L113.321 74.9414H119.261L123.161 96.0014H117.731L117.131 92.2814ZM116.531 88.3814L115.301 80.5814L111.281 88.3814H116.531Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M103.392 74.9414L99.6723 96.0014H94.5423L96.7923 83.3714L89.8323 96.0014H85.6923L83.1723 83.3114L80.9523 96.0014H75.8223L79.5423 74.9414H85.6023L88.9623 89.5214L97.3623 74.9414H103.392Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.582 74.9414C70.762 74.9414 72.422 75.4414 73.562 76.4414C74.702 77.4214 75.272 78.7014 75.272 80.2814C75.272 80.7414 75.232 81.1714 75.152 81.5714C74.912 82.9714 74.302 84.2214 73.322 85.3214C72.342 86.4214 71.032 87.2014 69.392 87.6614L72.782 96.0014H66.992L64.0219 88.0514H62.792L61.382 96.0014H56.252L59.972 74.9414H68.582ZM69.902 81.7814C69.942 81.4614 69.962 81.2514 69.962 81.1514C69.962 80.5114 69.752 80.0214 69.332 79.6814C68.932 79.3214 68.332 79.1414 67.532 79.1414H64.352L63.422 84.4214H66.602C67.542 84.4214 68.282 84.1914 68.822 83.7314C69.382 83.2714 69.742 82.6214 69.902 81.7814Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8604 74.9414L41.6404 87.5114C41.5604 88.0314 41.5204 88.3914 41.5204 88.5914C41.5204 89.5114 41.7804 90.2214 42.3004 90.7214C42.8204 91.2014 43.5904 91.4414 44.6104 91.4414C45.8104 91.4414 46.7904 91.1014 47.5504 90.4214C48.3104 89.7414 48.8004 88.7714 49.0204 87.5114L51.2404 74.9414H56.3704L54.1504 87.5114C53.8104 89.4114 53.1304 91.0214 52.1104 92.3414C51.1104 93.6414 49.8804 94.6114 48.4204 95.2514C46.9804 95.8914 45.4104 96.2114 43.7104 96.2114C41.5104 96.2114 39.7304 95.6414 38.3704 94.5014C37.0304 93.3614 36.3604 91.7114 36.3604 89.5514C36.3604 88.9114 36.4204 88.2314 36.5404 87.5114L38.7304 74.9414H43.8604Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2454 74.9414L35.5554 78.9914H29.9454L26.9454 96.0014H21.8154L24.8154 78.9914H19.2354L19.9554 74.9414H36.2454Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4298_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 32,
    width: 250,
    height: 65
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16 32H266V96.6458H16V32Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4298_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4298_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 36,
    width: 196,
    height: 28
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M199.046 45.0453C199.133 45 199.208 44.9344 199.265 44.8541C199.321 44.7737 199.357 44.681 199.37 44.5837C199.384 44.4865 199.373 44.3876 199.338 44.2957L196.747 37.1928C196.721 37.1247 196.712 37.0512 196.722 36.9789C196.731 36.9072 196.757 36.8389 196.799 36.78C196.839 36.7201 196.894 36.6715 196.959 36.6387C197.023 36.6058 197.094 36.5892 197.167 36.5905H206.17C206.263 36.5894 206.353 36.617 206.429 36.6695C206.505 36.7221 206.562 36.797 206.594 36.8838L211.218 49.562C211.241 49.6273 211.249 49.697 211.241 49.7658C211.233 49.8344 211.21 49.9003 211.173 49.9587L202.98 62.7711C202.939 62.8339 202.883 62.8856 202.817 62.9214C202.751 62.9573 202.677 62.9763 202.602 62.9768H193.735C193.655 62.978 193.575 62.9568 193.506 62.9155C193.437 62.8742 193.381 62.8144 193.344 62.7429C193.305 62.6714 193.287 62.591 193.29 62.5098C193.293 62.4287 193.317 62.3498 193.361 62.2813L197.769 55.3871C197.813 55.3179 197.843 55.2406 197.856 55.1597C197.87 55.0788 197.867 54.996 197.848 54.9162C197.829 54.8364 197.795 54.7612 197.746 54.6951C197.698 54.6289 197.637 54.5731 197.566 54.531C197.472 54.4754 197.364 54.4459 197.254 54.4457L16.6133 54.1494C16.5566 54.1497 16.5006 54.1368 16.4498 54.1118C16.3989 54.0869 16.3547 54.0505 16.3204 54.0054C16.2869 53.9596 16.2636 53.9072 16.2521 53.8516C16.2407 53.796 16.2414 53.7385 16.2543 53.6832L18.4513 45.0953C18.4709 45.0145 18.5171 44.9426 18.5823 44.8911C18.6476 44.8395 18.7283 44.8114 18.8115 44.8111V44.8213L198.764 45.1123H198.769C198.866 45.1124 198.961 45.0897 199.046 45.0453ZM206.168 36.3477H197.164C197.053 36.347 196.943 36.3732 196.845 36.4241C196.747 36.475 196.662 36.5491 196.599 36.64C196.535 36.7308 196.495 36.8358 196.481 36.9457C196.467 37.0556 196.48 37.1673 196.519 37.271L199.113 44.3739C199.132 44.43 199.138 44.4899 199.13 44.5487C199.122 44.6076 199.1 44.6637 199.066 44.7125C199.033 44.7613 198.988 44.8014 198.935 44.8295C198.882 44.8563 198.823 44.87 198.764 44.8698L18.8066 44.5735C18.6712 44.5744 18.5399 44.6203 18.4332 44.7038C18.3266 44.7874 18.2508 44.9039 18.2175 45.0352L16.0193 53.6265C15.9961 53.7166 15.9938 53.8108 16.0124 53.902C16.0311 53.9932 16.0702 54.079 16.1268 54.1528C16.1838 54.2267 16.257 54.2865 16.3407 54.3276C16.4247 54.3677 16.5165 54.3887 16.6095 54.3889L197.258 54.6897C197.324 54.6891 197.389 54.7062 197.447 54.7392C197.504 54.7723 197.551 54.8201 197.584 54.8776C197.616 54.9359 197.632 55.0017 197.63 55.0682C197.627 55.1351 197.607 55.2 197.57 55.2562L193.162 62.1535C193.095 62.2579 193.058 62.3784 193.055 62.5023C193.051 62.6261 193.081 62.7486 193.141 62.8569C193.199 62.9654 193.286 63.056 193.392 63.1188C193.498 63.1816 193.619 63.2142 193.742 63.2133H202.602L202.59 63.2193C202.706 63.2194 202.821 63.1904 202.923 63.1351C203.025 63.0791 203.111 62.9988 203.175 62.9012L211.37 50.0846C211.428 49.9956 211.463 49.8946 211.475 49.7895C211.486 49.6846 211.473 49.5785 211.437 49.4793L206.813 36.8022C206.767 36.6696 206.68 36.5547 206.566 36.4733C206.451 36.3918 206.314 36.348 206.174 36.3477H206.17",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4298_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.9961,
    y: 35.4219,
    width: 196.716,
    height: 28.1021,
    fill: "url(#pattern0_4298_2)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_4298_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 245,
    y: 32,
    width: 22,
    height: 36
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M255.289 32L248.36 42.7955H252.291L245.758 67.1914H256.581V67.1892L266.001 32H255.289Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_4298_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.001 32.002H245.758V67.193H266.001V32.002Z",
    fill: "url(#paint0_linear_4298_2)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_4298_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 32,
    width: 250,
    height: 65
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M266 32H16V96.6462H266V32Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_4298_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.282 66.9387H246.257L252.791 42.5416H249.063L255.5 32.5273H265.498L256.281 66.9406L256.282 66.9387ZM246.592 66.6797H256.086L265.168 32.7807H255.646L249.542 42.2799H253.135L246.6 66.6755L246.592 66.6797Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_4298_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 210,
    y: 32,
    width: 38,
    height: 36
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M234.812 42.8051C235.034 42.7812 235.259 42.8031 235.473 42.8694C235.686 42.9373 235.884 43.0475 236.053 43.1935C236.155 43.4126 236.212 43.6502 236.22 43.8919C236.228 44.1335 236.186 44.3743 236.098 44.5995H236.096C236.002 45.2076 235.681 45.7575 235.199 46.1395C234.716 46.5215 234.108 46.7074 233.494 46.6601H226.84L227.881 42.8051H234.812ZM219.937 32.0059L210.507 67.215H221.339L223.778 58.1068L230.449 67.215H243.931L236.284 56.756C241.595 55.2416 245.149 51.2468 246.856 44.8627H246.853C248.001 40.5768 247.741 37.3143 246.087 35.1552C244.485 33.0668 241.571 32.0059 237.422 32.0059H219.937Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_4298_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.001 32.0059H210.507V67.215H248.001V32.0059Z",
    fill: "url(#paint1_linear_4298_2)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_4298_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 32,
    width: 250,
    height: 65
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M266 32H16V96.6462H266V32Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_4298_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M243.304 66.813H230.781L230.743 66.7607L223.751 57.2149L221.183 66.8137H211.149L220.371 32.3828H237.557C241.58 32.3828 244.392 33.3904 245.918 35.3807C247.497 37.4371 247.733 40.5887 246.618 44.7547C244.888 51.209 241.245 55.1656 235.773 56.5194L243.305 66.8205L243.304 66.813ZM230.91 66.5551H242.798L235.339 56.3509L235.527 56.3047C241.001 55.0212 244.646 51.1098 246.368 44.6814C247.458 40.6026 247.243 37.5243 245.713 35.534C244.237 33.6129 241.495 32.6366 237.56 32.6366H220.571L211.486 66.5551H220.985L223.636 56.6269L230.909 66.5551H230.91ZM233.628 47.2841H226.135L227.524 42.1444H234.948C235.27 42.1092 235.595 42.1485 235.899 42.2593C236.203 42.3702 236.477 42.5496 236.701 42.7835C236.876 43.0766 236.981 43.4061 237.008 43.7465C237.035 44.0869 236.982 44.4288 236.855 44.7456C236.723 45.4913 236.321 46.1623 235.726 46.6306C235.131 47.0989 234.384 47.3318 233.628 47.2848L233.628 47.2841ZM226.474 47.025H233.628C234.327 47.074 235.02 46.8607 235.571 46.4267C236.121 45.9926 236.49 45.3691 236.606 44.6776C236.72 44.3984 236.769 44.097 236.751 43.796C236.732 43.495 236.645 43.2021 236.498 42.9392C236.298 42.7375 236.054 42.5841 235.786 42.4907C235.517 42.3973 235.231 42.3663 234.949 42.4001H227.722L226.474 47.025Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.223 67.2774L177.761 62.1528H162.979L159.774 67.2774H150.35L172.329 32.1055H184.624L187.766 67.2755L178.223 67.2774ZM175.879 41.4475L166.966 55.2303H176.838L175.879 41.4475Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.441 67.2755L141.873 54.4649H129.62L126.188 67.2755H116.664L126.083 32.1055H135.612L132.175 44.9179H144.428L147.862 32.1073H157.384L147.964 67.2774L138.441 67.2755Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.709 67.2755L103.129 32.1055H112.651L105.784 57.7267H116.033L113.477 67.2759L93.709 67.2755Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.7715 67.2755L88.1917 32.1055H97.7135L88.2932 67.2755H78.7715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0955 67.2774L55.2641 56.5834L52.4034 67.2774H42.8779L52.2982 32.1055H69.9623C74.0226 32.1055 76.8464 33.0991 78.351 35.0623C79.9115 37.0925 80.1303 40.2633 79.0014 44.4754C77.2167 51.1426 73.4433 55.1935 67.7784 56.5221L67.2645 56.6417L75.0294 67.2744H63.0955V67.2774ZM59.4341 41.1253L57.5623 47.6699H65.8005C66.6667 47.6432 67.4971 47.3187 68.1518 46.751C68.8066 46.1833 69.2455 45.4073 69.3946 44.5536C69.8864 42.725 69.5022 41.1261 67.6724 41.1261L59.4341 41.1253Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6984 67.2758L27.5656 41.6553H18.5957L21.1533 32.1035H48.614L46.0576 41.6527H37.0881L30.2202 67.2758H20.6984Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_4298_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 236,
    y: 74,
    width: 23,
    height: 23
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M243.209 90.3812C242.428 89.5612 242.032 88.445 242.032 87.019C242.016 85.7441 242.291 84.4823 242.835 83.3294C243.356 82.2412 244.154 81.3096 245.15 80.6286C246.177 79.9512 247.386 79.6002 248.616 79.6218C250.042 79.6218 251.137 80.0274 251.917 80.8248C252.697 81.6222 253.092 82.7309 253.092 84.1569C253.103 85.4442 252.818 86.7166 252.259 87.8766C251.757 88.967 250.967 89.9002 249.975 90.5763C248.96 91.2562 247.76 91.6077 246.538 91.5831C245.093 91.5831 243.988 91.1774 243.208 90.38M242.757 76.3318C240.866 77.4103 239.319 79.0005 238.292 80.9196C237.195 82.9593 236.641 85.2465 236.683 87.5619C236.651 89.1944 237.04 90.8077 237.811 92.247C238.541 93.5868 239.642 94.6879 240.981 95.4186C242.452 96.192 244.094 96.58 245.756 96.5464C248.047 96.5854 250.307 96.0192 252.31 94.905C254.209 93.816 255.766 92.217 256.804 90.2891C257.896 88.2259 258.449 85.9205 258.412 83.5866C258.443 81.9735 258.054 80.3799 257.284 78.9624C256.552 77.6208 255.438 76.5273 254.082 75.8209C252.601 75.0467 250.948 74.6596 249.277 74.6957C246.996 74.6589 244.746 75.2242 242.754 76.3344",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_4298_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.412 74.6953H236.683V96.5449H258.412V74.6953Z",
    fill: "url(#paint2_linear_4298_2)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_4298_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 226,
    y: 74,
    width: 10,
    height: 23
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M235.701 74.998H230.468L230.453 75.0804L226.719 96.2172L226.699 96.3345H232.052L232.066 96.2533L235.799 75.1153L235.82 74.998H235.701Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_4298_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.821 74.998H226.699V96.3349H235.821V74.998Z",
    fill: "url(#paint3_linear_4298_2)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_4298_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 203,
    y: 74,
    width: 22,
    height: 23
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M216.553 81.0772L217.721 88.4861H212.734L216.553 81.0772ZM220.578 74.998H214.556L214.528 75.0511L203.147 96.1883L203.066 96.3349H208.686L208.714 96.2807L210.613 92.6024H218.355L218.943 96.2518L218.957 96.3353H224.614L224.592 96.2168L220.676 75.0793L220.661 74.998H220.578Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_4298_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.613 74.998H203.066V96.3349H224.613V74.998Z",
    fill: "url(#paint4_linear_4298_2)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_4298_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 176,
    y: 74,
    width: 29,
    height: 23
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M204.652 74.9984H198.541L198.512 75.0484L190.209 89.4598L186.894 75.0755L186.876 74.998H180.629L180.614 75.0804L176.88 96.2172L176.859 96.3345H182.213L182.227 96.2522L184.363 84.0446L186.786 96.254L186.803 96.3345H191.1L191.128 96.2834L197.82 84.1401L195.668 96.2172L195.647 96.3345H201L201.015 96.2533L204.748 75.1153L204.769 74.998L204.652 74.9984Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_4298_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.771 74.998H176.86V96.3349H204.771V74.998Z",
    fill: "url(#paint5_linear_4298_2)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_4298_2",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_4298_2",
    transform: "scale(0.00510204 0.0357143)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4298_2",
    x1: 250.393,
    y1: 30.8055,
    x2: 278.565,
    y2: 51.2392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2172"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2121"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4298_2",
    x1: 219.093,
    y1: 30.8087,
    x2: 247.501,
    y2: 68.9557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2172"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2121"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4298_2",
    x1: 241.659,
    y1: 73.9524,
    x2: 259.598,
    y2: 96.4482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2172"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2121"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4298_2",
    x1: 228.788,
    y1: 74.2726,
    x2: 243.799,
    y2: 82.3642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2172"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2121"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4298_2",
    x1: 208,
    y1: 74.2726,
    x2: 225.457,
    y2: 96.5009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2172"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2121"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4298_2",
    x1: 183.252,
    y1: 74.2726,
    x2: 199.183,
    y2: 100.551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2172"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2121"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_4298_2",
    width: 196,
    height: 28,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMQAAAAcCAYAAAA+yxApAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACcSURBVHhe7dPBCoJAFEBRrf//ZsuwuMQoFi7PgQf6HGQ2d16WZbrQ/JzbNvc8/7rb2/979n2v3u97d/WZo29nzux9+36++v3Kf41mNdqfmdVoP5rV0fto97o8sBEEhCAgBAEhCAhBQAgCQhAQgoAQBIQgIAQBIQgIQUAIAkIQEIKAEASEICAEASEICEFACAJCEBCCgBAEhCDgY5oeHBgEM3xX3L8AAAAASUVORK5CYII="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoR1May);
export default __webpack_public_path__ + "static/media/logoR1-may.7149e42a38a7a8ea0c69e7dc9bc14457.svg";
export { ForwardRef as ReactComponent };